import styled from "styled-components";

export const Content = styled.div`
  flex: 1;
  padding-bottom:12px;
  border-bottom: 1px solid #E5E7EB;
`;